import { Autocomplete, Box, TextField } from "@mui/material";
import { UUID } from "crypto";

const Adset = ({ adset }: { adset: any }) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        onInputChange={adset.AdsetsData.handleSearchChange}
        options={
          adset.AdsetsData.AdsetsData
            ? [
                ...(adset.AdsetsData.AdsetsData?.map(
                  (adset: { name: string; id: string | UUID }) => ({
                    label: adset.name,
                    uid: adset.id,
                  })
                ) ?? []),
              ]
            : []
        }
        sx={{
          width: "100%",
        }}
        value={adset.state}
        loading={adset.AdsetsData.adsetsLoading}
        onChange={adset.handleChangeAdset}
        isOptionEqualToValue={(option, value) => option.label === value?.label}
        renderInput={(params) => (
          <TextField {...params} label="Find Adset" variant="outlined" />
        )}
      />
    </Box>
  );
};

export default Adset;
